import * as React from 'react';
import Page from '../Page';
import ReportAssignmentCore from '../core/ReportAssignmentCore';
import { TaxonomyTypeEnum } from '../../redux/TaxonomyVersionSlice';




const CR29Assignments = (props: any) => {
    return (
        <React.Fragment>
            <Page>
                <ReportAssignmentCore taxonomyType={TaxonomyTypeEnum.COURT_REPORTING_29} />
            </Page>
        </React.Fragment>
    );
}

export default CR29Assignments;